import {injectable} from "inversify";
import {AddressEntity} from "@dropDesk/domain/entities/common/address.entity";

@injectable()
export abstract class AddressRepository {
  public abstract searchAddress(address: string): Promise<AddressEntity>;
}
